import { get } from './apiService';
import type { EarningsRow } from '../types/earnings';

/**
 * Chef's earnings feed — one row per settled/settling payment on any listing
 * the caller listed. Backs the Pending segment of the My Earnings page.
 * BE endpoint filters payments to captured / captured-partial / cancelled;
 * snapshot is nullable per row (cancelled orders never captured, so no
 * snapshot). Sorted by payment.updated_at DESC on the server.
 */
export async function getMyEarnings(): Promise<EarningsRow[]> {
  return get<EarningsRow[]>('/orders/earnings');
}
